<template>
	<div
		class="w-25"
		:class="{
			'overflow-auto pr-1':
				$route.query.fromWebsite || $route.query.type == 'resumeClinic',
			'promocode-hs-maincontainer': isProgressSufficient || candProgressResp.createNewProfile,
		}"
		id="hideinmobile"
	>
		<!-- check if route has uuid "-->
		<div
			class="resumeclinic-card w-100 pl-2 mb-3"
			v-if="
				isLoading &&
				($route.query.uuid ||
					$route.query.fromWebsite ||
					$route.query.type == 'resumeClinic') &&
				$route.name != 'ViewPublicProfile'
			"
		>
			<b-card>
				<section
					class="d-flex align-items-start justify-content-between w-100 mb-2"
				>
					<div class="w-50">
						<b-skeleton class="w-75 h-10"></b-skeleton>
						<b-skeleton class="w-50 h-15 mt-3"></b-skeleton>
					</div>
					<div class="w-45 mt-1">
						<b-skeleton class="w-100 h-10"></b-skeleton>
						<b-skeleton class="w-75 h-10 mt-2 ml-auto"></b-skeleton>
						<b-skeleton class="w-50 h-10 mt-2 ml-auto"></b-skeleton>
					</div>
				</section>
				<div class="dashed-hr mt-3"></div>
				<section class="d-flex w-100 flex-wrap gap-3 position-relative mt-3">
					<div class="dashed-hr dashedmiddleline"></div>
					<div
						v-for="index in 6"
						:key="'resume-clinic-skeleton-' + index"
						class="w-45 mb-2"
					>
						<div class="d-flex align-items-center">
							<b-skeleton class="resume-clinic-skeleton-box mr-2"></b-skeleton>
							<b-skeleton class="w-75 h-10"></b-skeleton>
						</div>
					</div>
				</section>
				<div class="dashed-hr mb-2"></div>
				<b-skeleton class="w-100 h-10 mt-3"></b-skeleton>
				<b-skeleton class="w-75 h-10 mt-2"></b-skeleton>
				<b-skeleton class="h-10 mt-3" style="width: 42%"></b-skeleton>
			</b-card>
		</div>
		<div
			class="resumeclinic-card w-100 pl-2 mb-3"
			v-if="
			    (resumeClinicData && Object.keys(resumeClinicData).length != 0) &&
				!isLoading &&
				($route.query.uuid ||
					$route.query.fromWebsite ||
					$route.query.type == 'resumeClinic') &&
				$route.name != 'ViewPublicProfile' && candidateInfo?.resume_clinic_analysis != null
			"
		>
			<b-card>
				<section class="d-flex align-items-center w-100 mb-2">
					<div class="w-50">
						<h6 class="fw-M fs-16 fam-lato color-606060">Your Resume Score:</h6>
						<h5
							class="fs-24 fam-mont fw-B"
							:class="{
								'color-2AA869': overAllRating == 'Amazing',
								'color-F9C82B': overAllRating == 'Good',
								'color-e99e32': overAllRating == 'Okay',
								'color-d7342c': overAllRating == 'Fair',
							}"
						>
							{{ overAllRating }}
						</h5>
					</div>
					<div class="text-center position-relative mt-3">
						<img src="@/assets/newdesign/resumeclinic/resumemeter.svg" alt="" />
						<img
							class="position-absolute"
							src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/website/blackDial.svg"
							alt=""
							:class="getMeterClass"
						/>
					</div>
				</section>
				<div class="dashed-hr mt-3"></div>
				<!-- -->

				<section
					class="d-flex w-100 flex-wrap gap-3 position-relative mt-2"
					v-if="candidateData"
				>
					<div class="dashed-hr dashedmiddleline"></div>
					<div
						v-for="([key, value], index) in Object.entries(
							resumeClinicData || {}
						)"
						:key="index"
						class="w-45"
					>
						<div
							v-if="
								key !== 'uuid' &&
								key !== 'overall' &&
								key !== 'candidate_name' &&
								key !== 'candidate_email'
							"
							class="fam-lato fs-16 fw-M text-darkgrey d-flex align-items-center text-capitalize"
						>
							<div
								class="rc-rating-colorbox mr-1"
								:class="{
									'bg-boxgreen': value.rating == 1,
									'bg-boxyellow': value.rating == 2,
									'bg-boxorange': value.rating == 3,
									'bg-boxred': value.rating == 4,
								}"
							></div>
							<span v-if="key === 'personal_info'">Personal Info</span>
							<span v-else> {{ key }}</span>
						</div>
					</div>
				</section>
				<div class="dashed-hr mb-2"></div>
				<section class="fam-mont fw-LM fs-12 text-darkgrey">
					Resume clinic can be accessed from your Profile Page. This will
					automatically disappear in 24 hrs.
				</section>
				<section
					class="mt-2 fam-mont fs-14 fw-M text-blue pointer"
					@click="showresumeclinic = true"
				>
					View Insights
					<img
						src="../../../assets/newdesign/resumeclinic/rightcirclearw.svg"
						alt=""
					/>
				</section>
			</b-card>
		</div>
		<div
			class="candash-right-container invisible-scroll w-100"
			:class="{
				resumehelpsecheight:
					($route.query.uuid ||
					$route.query.fromWebsite ||
					$route.query.type == 'resumeClinic' ||
					candProgressResp.progress >= 70 ||
					candProgressResp.createNewProfile) && candidateInfo?.resume_clinic_analysis != null
			}"
		>
			<div
				v-if="showtstdiv"
				class="primary-tst d-flex align-items-center p-2 mt-2"
			>
				<div>
					<img
						style="height: 56px"
						src="../../../assets/newdesign/dashboard/notified_img.svg"
						alt=""
					/>
				</div>
				<div class="d-flex ml-2 primary-tst-text">
					You will be notified soon!
				</div>
			</div>
			<div
				class="mb-3"
				v-if="
					userInfo.onBoardingDocument.length > 0 &&
					$route.name != 'ViewPublicProfile'
				"
			>
				<div
					class="card-content card-content-blue doc-card-back position-relative"
				>
					<img
						class="rotating-border-img z-ind-1"
						style="opacity: 0.8"
						src="../../../assets/newbuilder/upload-doc.svg"
						alt=""
					/>
					<div class="d-flex align-items-center justify-content-between w-100">
						<div class="fam-mont fw-B fs-16 text-blue">Upload Documents</div>
					</div>

					<!-- Status message -->
					<div
						class="fam-mont fw-LM fs-16 text-5f5f5f mt-2 double-line-truncate position-relative z-ind-2"
					>
						{{ userInfo.onBoardingDocument[0].documentCount }} documents pending
						to be uploaded for Job
						<b>“{{ userInfo.onBoardingDocument[0].title }}”</b>
					</div>

					<!-- Progress pending tag -->

					<!-- Start now button or status tag -->
					<div>
						<b-button
							class="candash-addBtn mt-3 px-3"
							@click="
								goToOnboardingDocument(userInfo.onBoardingDocument[0].jobID)
							"
						>
							Upload Now
						</b-button>
					</div>
				</div>
			</div>
			<div
				class="rotating-border rotating-border-blue mb-3"
				v-if="
					(startedNow || userInfo.offers.interest === 'panelist') &&
					$route.name != 'ViewPublicProfile'
				"
			>
				<div class="card-content card-content-blue position-relative">
					<img
						class="rotating-border-img"
						src="../../../assets/newbuilder/panelist-dp.svg"
						alt=""
					/>
					<div class="d-flex align-items-center justify-content-between w-100">
						<div class="fam-mont fw-B fs-16 text-blue">
							Your panelist application:
						</div>
						<img
							v-if="progressPrimary.progress >= 70 && startedNow"
							class="pointer"
							src="../../../assets/newbuilder/right-profile-arrow.svg"
							alt=""
							@click="redirectApplicationResult"
						/>
					</div>

					<!-- Status message -->
					<div
						class="fam-mont fw-LM fs-14 text-3A3C40 mt-2"
						v-if="panelStatusMessage"
					>
						{{ panelStatusMessage }}
					</div>

					<!-- Progress pending tag -->
					<div v-if="showProgressPending" class="pending-tag mt-3">
						<img src="../../../assets/newbuilder/orange-clock.svg" alt="" />
						Profile completion pending
					</div>

					<!-- Start now button or status tag -->
					<div v-else>
						<b-button
							v-if="showStartNowButton"
							class="candash-addBtn-sm mt-3"
							@click="redirectToVerify"
						>
							Start Now
						</b-button>

						<div v-if="startedNow" :class="[currentStatusTag, 'mt-3']">
							<img :src="currentStatusIcon" alt="" />
							<span @click="redirectToApp">{{
								panelNotifications.message
							}}</span>
						</div>
					</div>
				</div>
			</div>

			<div
				class="noti-white-card p-3 position-relative"
				:style="
					$route.query.uuid ? 'height:unset;' : 'height:100%;min-height:770px'
				"
			>
				<div
					:class="{ 'noti-overflow': $route.query.uuid }"
					:style="
						$route.query.uuid
							? ''
							: '    height: calc(100vh - 128px);min-height:700px;'
					"
				>
					<div class="canddash-right-help-section" v-if="token">
						<div class="canddash-helpsec-header p-2">
							<div class="">Activities</div>
						</div>
						<div class="p-2 pl-3">
							<div class="cd-hs-act-heading">Recent</div>
							<div class="mt-1">
								<div
									v-for="(activity, index) in proActivities"
									:key="index"
									class="mt-2"
								>
									<div class="d-flex">
										<div class="d-flex align-items-end mr-3">
											<img
												src="../../../assets/icons/candidatedashboard/canddashright/recent.svg"
												alt=""
											/>
										</div>
										<div>
											<div
												class="profileName-text"
												v-if="activity.profileName != null"
											>
												{{ activity.profileName }}
											</div>

											<div class="cd-hs-recent-subheading">
												{{ activity.log }}
											</div>
										</div>
									</div>

									<!-- <div class="cd-hs-recent-time mt-2">1hour ago</div> -->
								</div>
								<!-- <div
                class="d-flex align-items-center mt-1 justify-content-between"
              >
                <div class="d-flex align-items-center">
                  <span class="mr-1"
                    ><img
                      src="../../../assets/icons/candidatedashboard/canddashright/recent.svg"
                      alt=""
                  /></span>

                  <span class="cd-hs-recent-heading mt-1"></span>
                  <span class="cd-hs-recent-subheading mt-1"
                    >Account Verified</span
                  >
                </div>
                <div class="cd-hs-recent-time mt-2">2days ago</div>
              </div> -->
							</div>
							<hr class="hr-back mt-2 mb-1" />
							<div class="cd-hs-act-heading">Upcoming</div>
							<div class="mt-1">
								<div class="d-flex align-items-center">
									<div class="d-flex align-items-center">
										<span
											><img
												class="mr-3"
												src="../../../assets/icons/candidatedashboard/canddashright/upcoming.svg"
												alt=""
										/></span>
										<span class="cd-hs-recent-subheading mt-1"
											>Create your profile
										</span>
									</div>
								</div>
								<div class="d-flex align-items-center mt-1">
									<div class="d-flex align-items-center">
										<span
											><img
												class="mr-3"
												src="../../../assets/icons/candidatedashboard/canddashright/upcoming.svg"
												alt=""
										/></span>

										<span class="cd-hs-recent-subheading mt-1"
											>Share your profile
										</span>
										<!-- <span class="cd-hs-recent-heading ml-1 mt-1">Create your profile </span> -->

										<!-- <span class="cd-hs-recent-subheading ml-1 mt-1">Share your</span>
                <span class="cd-hs-recent-heading mt-1">
                  &nbsp;profile</span
                > -->
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="token"
						@click="goToInterviewPrep()"
						class="pointer cd-hs-interview canddash-right-help-section position-relative p-3 d-flex mt-2"
					>
						<div class="cd-hs-pi-firsticon">
							<img
								src="../../../assets/icons/candidatedashboard/canddashright/interview.svg"
								alt=""
							/>
						</div>
						<div style="width: 74%">
							<div class="cd-hs-pi">Prepare for an Interview</div>
							<div class="cd-hs-pi-sh">Assess yourself to get hired</div>
						</div>
						<div class="cd-hs-pi-endicon">
							<img
								src="../../../assets/icons/candidatedashboard/canddashright/goto.svg"
								alt=""
							/>
						</div>
					</div>

					<!-- <div class="canddash-right-help-section mt-2" v-if="token">
          <div
            class="canddash-helpsec-header p-2 d-flex justify-content-between"
          >
            <div class="">Refer a friend</div>
            <div class="position-relative">
              <img
                src="../../../assets/img/icon.svg"
                alt="icon"
                @mouseenter="referHover = true"
                @mouseleave="referHover = false"
              />
              <div class="refer-info" v-if="referHover">
                <div
                  class="d-flex align-items-center asp-small-txt text-center"
                >
                  Referrals are counted only if the <br />
                  reference registers and downloads <br />the resume
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="token"
          @click="$bvModal.show('coming-soon'), (showSvg = true)"
          class="pointer cd-hs-interview canddash-right-help-section position-relative p-3 d-flex mt-2"
        >
          <div class="cd-hs-pi-firsticon">
            <img
              src="../../../assets/icons/candidatedashboard/canddashright/interview.svg"
              alt=""
            />
          </div>
          <div style="width: 74%">
            <div class="cd-hs-pi">Prepare for an Interview</div>
            <div class="cd-hs-pi-sh">Assess yourself to get hired</div>
          </div>
          <div class="cd-hs-pi-endicon">
            <img
              src="../../../assets/icons/candidatedashboard/canddashright/goto.svg"
              alt=""
            />
          </div>
        </div>

        <!-- <div class="canddash-right-help-section mt-2" v-if="token">
          <div
            class="canddash-helpsec-header p-2 d-flex justify-content-between"
          >
            <div class="">Refer a friend</div>
            <div class="position-relative">
              <img
                src="../../../assets/img/icon.svg"
                alt="icon"
                @mouseenter="referHover = true"
                @mouseleave="referHover = false"
              />
              <div class="refer-info" v-if="referHover">
                <div
                  class="d-flex align-items-center asp-small-txt text-center"
                >
                  Referrals are counted only if the <br />
                  reference registers and downloads <br />the resume
                </div>
              </div>
            </div>
          </div>
          <div class="p-2">
            <div class="cd-hs-heading d-flex justify-content-between">
            <span>Referral Code:</span>  
              <div v-if="codeCopied">
                <img
                  src="../../../assets/newdesign/dashboard/greyTick.svg"
                  class="mr-1"
                />
                <span class="copied-link">Copied</span>
              </div>
            </div>

            <div class="w-100 mt-2">
              <div class="referral-code position-relative px-1 py-1">
                <span id="test-link"> {{ myreferralCode }}</span>
                <img
                  @click="copyTheCode(myreferralCode)"
                  class="referral-copyicon position-absolute pointer"
                  src="../../../assets/img/pasteicon.svg"
                  alt="paste-icon"
                />
              </div>
            </div>

            <div v-if="referralCount > 0" class="tot-referral mt-2 mb-2">
              Total Number of Referrals: {{ referralCount }}
            </div>
            <div v-else class="tot-referral mt-2">Start referring now!</div>
            <div class="w-97 pl-2 d-flex justify-content-center">
              <img
                class="mt-1 mb-1 w-100"
                src="../../../assets/img/referralgift.svg"
                alt=""
              />
            </div>

        
          </div>
        </div> -->

					<div class="canddash-right-help-section mt-2 faqcontainer">
						<div class="canddash-helpsec-header p-2">
							<div class="">FAQ</div>
						</div>
						<div class="cd-helpsec-cards mt-2 m-2">
							<b-row>
								<b-col
									cols="12"
									class="d-flex pointer align-items-center"
									@click="goToFAQ('switch')"
								>
									<div class="cd-helpsec-card-heading" style="width: 95%">
										Can I switch between multiple profiles?
									</div>
									<img
										src="../../../assets/icons/candidatedashboard/canddashright/rightarrow.svg"
										class="ml-2"
										alt=""
									/>
									<!-- <div class="cd-helpsec-cards-viewguide mt-3 pointer">
                View Guide
               
              </div> -->
								</b-col>
								<!-- <b-col cols="3">
              <img
                src="../../../assets/icons/candidatedashboard/canddashright/portfolios.svg"
                alt=""
              />
            </b-col> -->
							</b-row>
						</div>
						<div class="cd-helpsec-cards mt-2 m-2">
							<b-row>
								<b-col
									cols="12"
									class="d-flex pointer align-items-center"
									@click="goToFAQ('video')"
								>
									<div style="width: 95%" class="cd-helpsec-card-heading">
										How do I create a Video Snapshot?
									</div>
									<img
										src="../../../assets/icons/candidatedashboard/canddashright/rightarrow.svg"
										class="ml-2"
										alt=""
									/>
									<!-- <div class="cd-helpsec-cards-viewguide mt-3 pointer">
                View Guide
                <img
                  src="../../../assets/icons/candidatedashboard/canddashright/rightarrow.svg"
                  class="ml-2"
                  alt=""
                />
              </div> -->
								</b-col>
								<!-- <b-col cols="3">
              <img
                src="../../../assets/icons/candidatedashboard/canddashright/guide.svg"
                alt=""
              />
            </b-col> -->
							</b-row>
						</div>
						<div
							class="mt-2 mb-2 canddash-right-viewmore d-flex justify-content-center pointer"
							@click="goToFAQ('graphical')"
						>
							View more
						</div>
					</div>
					<!-- PROMO CODE design starts from here -->
					<section
						class="promo-code-card mt-2"
						v-if="
							isProgressSufficient ||
							candProgressResp.createNewProfile
						"
					>
						<b-card>
							<section class="d-flex align-items-center w-100 promo-code-head">
								<img
									src="../../../assets/icons/maindashboard/promo-svg.svg"
									alt=""
								/>
								Enter Promo Code
							</section>
							<section class="promo-code-subhead">
								Apply promo code now to unlock the best offers from Hire3x!
							</section>

							<section class="mt-1 promo-code-taketest" v-b-modal.promoCode>
								Use Promo Code
								<img
									src="../../../assets/icons/candidatedashboard/canddashright/rightarrow.svg"
									alt=""
								/>
							</section>
						</b-card>
					</section>
				</div>
				<div class="cd-hlepsec-footer">
					<div
						class="cd-helpsec-icon-card cd-right-snapshot-heading d-flex justify-content-center mt-2"
					>
						Follow Us
					</div>
					<div
						class="cd-helpsec-icon-card d-flex justify-content-center align-items-center"
					>
						<div>
							<a
								href="https://www.instagram.com/hire3x?igsh=MWQ0bzhqandjenprYg=="
								id="insta"
								target="_blank"
							>
								<img
									src="../../../assets/icons/candidatedashboard/canddashright/Instagram.svg"
									alt=""
							/></a>
						</div>
						<div class="ml-3">
							<a
								href="https://www.facebook.com/profile.php?id=61552725574787&mibextid=AEUHqQ"
								id="fb"
								target="_blank"
							>
								<img
									src="../../../assets/icons/candidatedashboard/canddashright/Facebook.svg"
									alt=""
							/></a>
						</div>
						<div class="ml-3">
							<a
								href="https://www.twitter.com/hire3x/"
								id="twitter"
								target="_blank"
							>
								<img
									src="../../../assets/icons/candidatedashboard/canddashright/twitter.svg"
									alt=""
							/></a>
						</div>
						<div class="ml-3">
							<a
								href="https://www.linkedin.com/company/hire3x/"
								id="linkedin"
								target="_blank"
							>
								<img
									src="../../../assets/icons/candidatedashboard/canddashright/Linkedin.svg"
									alt=""
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal centered hide-footer hide-header id="coming-soon">
			<div class="relativeclass">
				<div
					v-if="showSvg"
					class="rocket-container d-flex justify-content-center"
					ref="rocketContainer"
				>
					<div
						@click="$bvModal.hide('coming-soon')"
						class="d-flex justify-content-end pointer"
					>
						<img
							class="rotate-on-hover"
							style="position: absolute; right: 3px"
							src="../../../assets/newdesign/dashboard/button_close_x.svg"
						/>
					</div>
					<img
						class="rocket"
						src="../../../assets/newdesign/dashboard/rocket.svg"
					/>
				</div>
				<div class="cmg-soon-txt">COMING SOON</div>
				<div class="txt-cmg-soon pt-1">
					We are launching interview preparations very soon!
				</div>
				<div class="d-flex justify-content-center cmg-soon-btn pointer">
					<b-button
						@click="launchRocket"
						class="btn btn-secondary candash-addBtn"
						>Notify me</b-button
					>
				</div>
			</div>
		</b-modal>
		<InterviewPrepModal
			v-if="interviewPrepModal"
			:showMod="interviewPrepModal"
			:fromAnotherPage="false"
			@close-modal="hideModal()"
		/>

		<ResumeClinic
			v-if="showresumeclinic"
			:showModal="showresumeclinic"
			@modalClose="modalClose"
			:showfromhelpsection="true"
			:clinicDatafromhs="resumeClinicData"
		/>
		<seventyPercentModal
			v-if="completeModal"
			:showModal="completeModal"
			@close-modal="completeModal = false"
		/>
		<!-- promo code modal starts here -->
		<b-modal
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			id="promoCode"
			size="lg"
		>
			<section class="d-flex w-100 justify-content-end">
				<img
					@click="closeModal"
					class="rotate-on-hover pointer"
					src="../../../assets/newdesign/dashboard/blueCross.svg"
					alt=""
				/>
			</section>
			<section class="text-center w-100">
				<section>
					<img
						src="../../../assets/icons/maindashboard/promo-modal-img.svg"
						alt=""
					/>
				</section>
				<section class="promoCode-modal-head">Enter the Promo Code</section>
				<section class="promoCode-modal-subhead">
					Apply promo code now to unlock the best offers from Hire3x!
				</section>

				<section
					:class="
						promoSuccess
							? 'promoCode-modal-input-linkPR'
							: 'promoCode-modal-input-buttonPR'
					"
					class="promoCode-modal-input position-relative mt-3"
				>
					<b-form-input
						autofocus
						v-model.trim="myPromoCode"
						placeholder="Enter"
						:class="{
							'promoCode-error': promoError,
							'promoCode-success': promoSuccess,
						}"
						@input="(promoError = false), (promoSuccess = false)"
						@keyup.enter="applyPromo"
					>
					</b-form-input>
					<section
						:class="
							promoSuccess ? 'promoCode-link-top' : 'promoCode-button-top'
						"
						class="promoCode-position position-absolute"
					>
						<section v-if="promoSuccess" class="promoCode-link-sent">
							<img
								src="../../../assets/icons/maindashboard/promo-link-sent-icon.svg"
								alt=""
							/>
							Applied
						</section>
						<b-button
							v-else
							@click="applyPromo"
							:disabled="myPromoCode === ''"
							class="candash-addBtn"
						>
							Apply
						</b-button>
					</section>

					<section
						v-if="promoError"
						class="position-absolute promoCode-error-txt mt-1"
					>
						{{ invalidText }}
					</section>
				</section>
				<section></section>
			</section>
		</b-modal>
	</div>
</template>
<script>
import ResumeClinic from "@/components/BuilderPage/ResumeclinicModal.vue";
import InterviewPrepModal from "@/components/MyProfile/NoskillPrepareInterview.vue";
import { mapGetters } from "vuex";
import { getToken } from "../../../utils/tokenCheck";
import EventBus from "../../../utils/EventBus.js";
import seventyPercentModal from "../../../components/BuilderPage/SeventyPercentModal.vue";
import {
	profileActivities,
	//For Referral
	getCandReferral,
	applyPromoCode,
	getPanelNotification,
	getCvsDetails,
} from "../../../utils/apiFunctions.js";
import { routes } from "@/router/index.js";
import { config } from "@/config";
export default {
	name: "HelpSection",
	components: {
		InterviewPrepModal,
		ResumeClinic,
		seventyPercentModal,
	},
	watch:{
		progressPrimary(newVal){
			this.isProgressSufficient
		}
	},
	computed: {
		...mapGetters("userVUEX", {
			// token: "getToken",
			userInfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
			candProgressResp: "getCandProgressResp",
			candidateData: "getPrimaryCandidateInfo",
			progressPrimary: "getCandProgressRespPrimary",
		}),
		config() {
			return config;
		},
		overAllRating() {
			if (this.resumeClinicData && Object.keys(this.resumeClinicData).length) {
				if (this.overallScore === 1) {
					return "Amazing";
				} else if (this.overallScore === 2) {
					return "Good";
				} else if (this.overallScore === 3) {
					return "Okay";
				} else {
					return "Fair";
				}
			}
		},
		getMeterClass() {
			if (this.resumeClinicData && Object.keys(this.resumeClinicData).length) {
				const score = parseInt(this.overallScore);
				switch (score) {
					case 1:
						return "amzing-dial";
					case 2:
						return "good-dial";
					case 3:
						return "okay-dial";
					case 4:
						return "fair-dial";
				}
			}
		},
		resumeClinicData() {
			return this.candidateInfo?.resume_clinic_analysis;
		},
		overallScore() {
			return this.candidateInfo?.resume_clinic_analysis?.overall?.rating;
		},
		panelStatusMessage() {
			const progress = this.progressPrimary.progress;
			const started = this.startedNow;
			const status = this.panelNotifications.status;

			if (progress < 70 && !started) {
				return "Please complete your profile before submitting your application.";
			} else if (progress >= 70 && !started) {
				return "You are ready to become a panelist. Click on “Start now” to begin the process.";
			} else if (started && status !== "selected" && status !== "rejected") {
				return "Your panelist application is in progress. Complete the steps to proceed!";
			} else if (status === "rejected") {
				return "Your panelist application is not approved. You can reapply later!";
			} else if (status === "selected") {
				return "Congratulations! Your panelist application is approved. Get started now!";
			} else {
				return "";
			}
		},

		showStartNowButton() {
			return this.progressPrimary.progress >= 70 && !this.startedNow;
		},

		showProgressPending() {
			return this.progressPrimary.progress < 70;
		},

		currentStatusTag() {
			const status = this.panelNotifications.status;
			if (status === "rejected") return "rejected-tag";
			if (status === "accepted") return "accepted-tag";
			return "pending-tag";
		},

		currentStatusIcon() {
			const status = this.panelNotifications.status;
			if (status === "accepted")
				return "../../../assets/newbuilder/panel-approved.svg";
			if (status === "rejected")
				return "../../../assets/newbuilder/panel-rejected.svg";
			return "../../../assets/newbuilder/orange-clock.svg";
		},
		isProgressSufficient() {
			const level = this.candidateInfo.experienceLevel;
			const progress = this.progressPrimary.progress;

			if (level === "fresher") return progress >= 50;
			if (level === "intermediate" || level === "senior") return progress >= 70;
			return false;
		},
		token(){
			return getToken();
		}
	},
	data() {
		return {
			showSvg: true,
			showtstdiv: false,
			proActivities: [],
			myreferralCode: "",
			referralCount: null,
			referHover: false,
			codeCopied: false,
			interviewPrepModal: false,
			promoError: false,
			promoSuccess: false,
			myPromoCode: "",
			invalidText: "",
			panelNotifications: {},
			startedNow: false,
			showresumeclinic: false,
			// resumeClinicData: {},
			// overallScore: null,
			completeModal: false,
		};
	},
	props: {
		referalCode: String,
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	created() {
		// if (this.$route?.query?.uuid) {
		// 	this.$store.commit("userVUEX/SET_RESUME_UUID", this.$route.query.uuid);
		// } else {
		// 	this.$store.commit("userVUEX/SET_RESUME_UUID", null);
		// }
		this.fetchPanelStat();
		this.getNotified();
		if (this.token) {
			this.myreferralCode = this.referalCode;
			this.getReferralCode();
			this.profileActivities();
		}
	},
	watch: {
		candidateInfo: {
			handler(newVal) {
				if (newVal?.resume_clinic_analysis) {
					this.resumeClinicData = newVal.resume_clinic_analysis;
					this.overallScore = newVal.resume_clinic_analysis.overall?.rating;
				}
				else this.resumeClinicData = {}
			},
			immediate: true,
		},
		referalCode() {
			this.myreferralCode = this.referalCode;
		},
	},
	mounted() {
		EventBus.$on("helpSectionUpdate", this.helpSectionUpdate);
	},
	methods: {
		async applyPromo() {
			try {
				let payload = {
					// email: this.candidateInfo.email,
					code: this.myPromoCode,
				};
				const res = await applyPromoCode(payload);
				if (res.status === 200) {
					this.promoError = false;
					this.promoSuccess = true;
					setTimeout(() => {
						this.$bvModal.hide("promoCode");
					}, 3000);
					EventBus.$emit("updateUserInfo");
				} else if (res.status === 404 || res.status === 208) {
					this.promoError = true;
					this.promoSuccess = false;
					this.invalidText = res.data.data.Detail;
					console.log("resss", res);
					EventBus.$emit("updateUserInfo");
				}
			} catch (error) {
				console.error(error);
			}
		},
		closeModal() {
			this.$bvModal.hide("promoCode");
			this.promoError = false;
			this.promoSuccess = false;
			this.myPromoCode = "";
		},
		goToAssessmentProg() {
			this.$router.push({
				name: "AssessmentCategory",
			});
		},
		goToOnboardingDocument(jobID) {
			this.$router.push({
				name: "OnboardingDocuments",
				query: {
					jobID: jobID,
				},
			});
		},
		modalClose() {
			this.showresumeclinic = false;
		},
		redirectToApp() {
			if (
				this.panelNotifications.status == "selected" ||
				this.panelNotifications.status == "rejected"
			) {
				this.$router.push({
					name: "ResultDashboard",
				});
			} else {
				this.$router.push({
					name: "ApplicationResult",
				});
			}
		},
		redirectApplicationResult() {
			this.$router.push({
				name: "ApplicationResult",
			});
		},
		redirectToVerify() {
			if (this.candidateData.experienceLevel == "fresher") {
				this.$router.push({
					name: "BecomePanelist",
				});
			} else if (this.progressPrimary.progress >= 70) {
				this.$router.push({
					name: "VerifyAccount",
				});
			} else {
				// this.$bvModal.show("completeSeventy");
				this.completeModal = true;
			}
		},
		async fetchPanelStat() {
			try {
				const res = await getCvsDetails();
				if (res.status == 200) {
					this.startedNow = true;
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getNotified() {
			try {
				const res = await getPanelNotification();
				if (res.status == 200) {
					this.panelNotifications = res.data.data;
				} else {
					console.log("error occured in panel notified");
				}
			} catch (error) {
				console.log(error, "error for panel notified");
			}
		},
		hideModal() {
			this.interviewPrepModal = false;
		},
		openLink() {
			window.open("https://youtu.be/vczpIL2FZpA?si=I9Vn1n1hD2GQ94qs", "_blank");
		},
		goToInterviewPrep() {
			if (
				Object.keys(this.candidateData).length > 0 &&
				this.candidateData.skills
			) {
				const OnlySkills = this.candidateData.skills.filter(
					(link) => link.parser != true
				);
				if (OnlySkills.length > 0) {
					this.$router.push({ name: "InterviewKickstart" });
				} else {
					this.interviewPrepModal = true;
					// this.$bvModal.show("interviewPrepModal");
				}
			}
		},
		helpSectionUpdate() {
			this.profileActivities();
		},
		async profileActivities() {
			const response = await profileActivities();
			this.proActivities = response.data.data;
		},
		goToFAQ(data) {
			// Construct the URL with the provided data as a query parameter
			const url = `${
				this.config.websiteBase
			}contactus/?scrollTo=${encodeURIComponent(data)}`;

			// Open the URL in a new window
			window.open(url, "_blank");
		},
		goToVideoResume() {
			this.$router.push({ name: "systemcheck" });
		},
		goToPreviewResume() {
			this.$router.push({ name: "previewvideoresume" }, () => {
				this.$router.go(0);
			});
		},
		launchRocket() {
			// Optional: You can also hide the rocket after sliding up

			this.$bvModal.hide("coming-soon");
			this.showtstdiv = true;
			// Adjust the timeout based on your animation duration
			// Adjust the timeout based on your shake animation duration
			setTimeout(() => {
				this.showtstdiv = false;
			}, 3000);
		},
		//For getting the referral Code
		async getReferralCode() {
			try {
				const resp = await getCandReferral();
				if (resp.status == 200) {
					this.referralCount = resp.data.data.referalCount;
					if (this.referralCount < 10) {
						this.referralCount = "0" + this.referralCount;
					}
					EventBus.$emit("passReffCount", this.referralCount);
				} else {
					console.log("Api Error");
				}
			} catch (error) {
				console.log(error);
			}
		},
		copyTheCode(refCode) {
			this.$copyToClipboard(refCode);
			this.codeCopied = true;
			setTimeout(() => {
				this.codeCopied = false;
			}, 5000);
		},
	},
};
</script>
<style>
.profileName-text {
	font-size: 8px;
	font-style: italic;
	font-weight: 500;
	color: #7a7a7a;
}

.canddash-right-viewmore {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	color: #20639b;
}

.rocket-container {
	position: relative;
	overflow: hidden;
	height: 144px; /* Set the height of the container to match the rocket's height */
}

.rocket {
	position: absolute;
	bottom: 0;
}

.primary-tst {
	background-color: #ffffff;
	position: absolute;
	border-radius: 10px;
	box-shadow: 10px 10px 70px rgba(0, 0, 0, 0.15);
	right: -95px;
	top: 20px;
	width: 327px;
	height: 70px;
	z-index: 10;
	transform: translateX(-50%);
	animation: dropAndDisappear 1s ease forwards, disappear 1s 2s forwards;
}
.cmg-soon-txt {
	/* COMING SOON */

	width: 100%;
	height: 30px;

	font-family: "Montserrat";
	font-weight: 400;
	font-size: 25px;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
	letter-spacing: 0.16em;

	color: #20639b;

	/* Inside auto layout */
	flex: none;
	order: 0;
	flex-grow: 0;
}
.primary-tst-text {
	font-family: "Lato";
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	padding-left: 10px;
}
@keyframes dropAndDisappear {
	0% {
		top: -100px;
	}
	100% {
		top: 45px;
	}
}

@keyframes disappear {
	100% {
		top: -100px;
	}

	0% {
		top: 45px;
	}
}

.cd-hs-heading {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #20639b;
}

.referral-code {
	border-radius: 3px;
	background: #e8eff4;
}

.referral-code span {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #3d5a8080;
}

.w-97 {
	width: 97%;
}

.referral-copyicon {
	top: 5px;
	right: 10px;
}

.tot-referral {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #7a7a7a;
}

.cd-hs-heading {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #20639b;
}

.referral-code {
	border-radius: 3px;
	background: #e8eff4;
}

.referral-code span {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #3d5a8080;
}

.w-97 {
	width: 97%;
}

.referral-copyicon {
	top: 5px;
	right: 10px;
}

.tot-referral {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #7a7a7a;
}

/* promo code new design */
.promo-code-card .card {
	background: linear-gradient(
		180.33deg,
		rgba(32, 99, 155, 0.62) 18.2%,
		#414141 99.71%
	);
	border-radius: 8px;
	padding: 12px;
	border: unset;
}

.promo-code-card .card-body {
	padding: 0px;
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.promo-code-head {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 24px;
	color: #ffffff;
	gap: 5px;
}

.promo-code-subhead {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	color: #fafafa;
}

.promo-code-taketest {
	background: #fff;
	border-radius: 20px;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 11px;
	line-height: 13px;
	display: flex;
	align-items: center;
	text-align: center;
	justify-content: center;
	padding: 5px;
	color: #1f629b;
	gap: 10px;
}

#promoCode .modal-body {
	padding: 40px 50px 50px 50px;
	border-radius: 8px;
}
@media (min-width: 992px) {
	#promoCode .modal-lg,
	#promoCode .modal-xl {
		max-width: 720px;
	}
}

.promoCode-modal-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 24px;
	line-height: 46px;
	text-align: center;

	color: #170f49;
}

.promoCode-modal-subhead {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 46px;
	text-align: center;

	color: #6f6c90;
}

.promoCode-modal-input .form-control {
	box-shadow: 0px 2px 6px 0px #13124212;
	border-radius: 60px;
	background: #ffffff;
	border: 1px solid #eff0f6;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: #333333;
	height: 50px;
	padding-left: 30px;
}

.promoCode-modal-input .form-control:focus {
	border: 1px solid #80bdff !important;
}

.promoCode-modal-input-buttonPR .form-control {
	padding-right: 152px;
}

.promoCode-modal-input-linkPR .form-control {
	padding-right: 115px;
}

.promoCode-error.form-control {
	border: 1px solid #eb0002;
}

.promoCode-success.form-control {
	border: 1px solid #038e00;
}

.promoCode-position {
	right: 15px;
}

.promoCode-button-top {
	top: 9px;
}

.promoCode-link-top {
	top: 15px;
}

.promoCode-link-sent {
	display: flex;
	align-items: center;
	gap: 10px;

	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #038e00;
}

.promoCode-error-txt {
	font-family: "Montserrat", sans-serif;

	font-weight: 500;
	font-size: 14px;
	color: #eb0002;
	left: 30px;
}
.pending-tag {
	display: flex;
	align-items: center;
	gap: 10px;
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #f47529;
	background: #ffdd806b;
	border-radius: 4px;
	width: fit-content;
	padding: 4px 10px;
	position: relative;
	z-index: 1;
}

.accepted-tag {
	display: flex;
	align-items: center;
	gap: 10px;
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #038e00;
	background: #dbece6;
	border-radius: 4px;
	width: fit-content;
	padding: 4px 10px;
	position: relative;
	z-index: 1;
}

.rejected-tag {
	display: flex;
	align-items: center;
	gap: 10px;
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #ad1927;
	background: #f0e3ea;
	border-radius: 4px;
	width: fit-content;
	padding: 4px 10px;
	position: relative;
	z-index: 1;
}
.resumeclinic-card .card {
	background: #f6f9fb;
	border-radius: 8px;
}
.resumeclinic-card .card-body {
	background: #f6f9fb;
	border-radius: 8px;
	padding: 15px;
}
.color-606060 {
	color: #606060;
}
.rc-rating-colorbox {
	width: 16px;
	height: 16px;
	border-radius: 2px;
}
.bg-boxred {
	background: #ec0d06;
}
.bg-boxgreen {
	background: #2aa869;
}
.bg-boxorange {
	background: #ef9727;
}
.bg-boxyellow {
	background: #f9c82b;
}
.dashed-hr {
	border: 1px dashed #8c8c8c;
	width: 100%;
}
.dashedmiddleline {
	position: absolute;
	top: -3px;
	right: 58%;
	border: 1px dashed #c1c2c3;
	height: 100%;
	width: 0%;
}
.w-45 {
	width: 45%;
}
.resumehelpsecheight {
	height: fit-content;
}
.doc-card-back {
	background-image: url("../../../assets/newbuilder/doc-back.png");
	background-repeat: no-repeat;
	background-size: cover;
	/* display: flex;
	justify-content: space-between;
	border-radius: 8px;
	box-shadow: 0px 4px 8px 0px #0000002b;
	background-color: #f3f6ff;
	width: 100%;
	position: relative; */
}
.promocode-hs-maincontainer {
	height: calc(100vh - 85px);
	overflow: auto;
	padding-right: 5px;
}
</style>
